import isSvg from 'is-svg';
import logger from '../logger.js';
export default class {
    _views = [];
    _currentView = null;
    constructor() {
        logger.debug('Navigation service initialized');
    }
    register(view) {
        try {
            isValidNavigation(view);
            isUniqueNavigation(view, this._views);
        }
        catch (e) {
            if (e instanceof Error) {
                logger.error(e.message, { view });
            }
            throw e;
        }
        if (view.legacy) {
            logger.warn('Legacy view detected, please migrate to Vue');
        }
        if (view.iconClass) {
            view.legacy = true;
        }
        this._views.push(view);
    }
    remove(id) {
        const index = this._views.findIndex(view => view.id === id);
        if (index !== -1) {
            this._views.splice(index, 1);
        }
    }
    get views() {
        return this._views;
    }
    setActive(view) {
        this._currentView = view;
    }
    get active() {
        return this._currentView;
    }
}
/**
 * Make sure the given view is unique
 * and not already registered.
 */
const isUniqueNavigation = function (view, views) {
    if (views.find(search => search.id === view.id)) {
        throw new Error(`Navigation id ${view.id} is already registered`);
    }
    return true;
};
/**
 * Typescript cannot validate an interface.
 * Please keep in sync with the Navigation interface requirements.
 */
const isValidNavigation = function (view) {
    if (!view.id || typeof view.id !== 'string') {
        throw new Error('Navigation id is required and must be a string');
    }
    if (!view.name || typeof view.name !== 'string') {
        throw new Error('Navigation name is required and must be a string');
    }
    /**
     * Legacy handle their content and icon differently
     * TODO: remove when support for legacy views is removed
     */
    if (!view.legacy) {
        if (!view.getContents || typeof view.getContents !== 'function') {
            throw new Error('Navigation getContents is required and must be a function');
        }
        if (!view.icon || typeof view.icon !== 'string' || !isSvg(view.icon)) {
            throw new Error('Navigation icon is required and must be a valid svg string');
        }
    }
    if (!('order' in view) || typeof view.order !== 'number') {
        throw new Error('Navigation order is required and must be a number');
    }
    // Optional properties
    if (view.columns) {
        view.columns.forEach(isValidColumn);
    }
    if (view.emptyView && typeof view.emptyView !== 'function') {
        throw new Error('Navigation emptyView must be a function');
    }
    if (view.parent && typeof view.parent !== 'string') {
        throw new Error('Navigation parent must be a string');
    }
    if ('sticky' in view && typeof view.sticky !== 'boolean') {
        throw new Error('Navigation sticky must be a boolean');
    }
    if ('expanded' in view && typeof view.expanded !== 'boolean') {
        throw new Error('Navigation expanded must be a boolean');
    }
    if (view.defaultSortKey && typeof view.defaultSortKey !== 'string') {
        throw new Error('Navigation defaultSortKey must be a string');
    }
    return true;
};
/**
 * Typescript cannot validate an interface.
 * Please keep in sync with the Column interface requirements.
 */
const isValidColumn = function (column) {
    if (!column.id || typeof column.id !== 'string') {
        throw new Error('A column id is required');
    }
    if (!column.title || typeof column.title !== 'string') {
        throw new Error('A column title is required');
    }
    if (!column.render || typeof column.render !== 'function') {
        throw new Error('A render function is required');
    }
    // Optional properties
    if (column.sort && typeof column.sort !== 'function') {
        throw new Error('Column sortFunction must be a function');
    }
    if (column.summary && typeof column.summary !== 'function') {
        throw new Error('Column summary must be a function');
    }
    return true;
};
